const facilitiesRoute = createApiRoute(ApiModule.PRODUCTION_PLANNING, ApiModule.EMPLOYEE, ApiDataModel.FACILITIES)
const facilitiesAuthRoute = createApiRoute(ApiModule.AUTH, ApiDataModel.FACILITIES)

export const apiFacility = {
	fetchFacilities: async (): Promise<IFacilityModel[]> => {
		const { data } = await apiCommon<IFacility[]>(facilitiesRoute, { method: 'GET' })

		return data ? data.map(d => Facility(d)) : []
	},

	fetchFacilityById: async (id: string): Promise<IFacilityDetailModel | null> => {
		const { data } = await apiCommon<IFacilityDetail>(`${facilitiesAuthRoute}/${id}`, { method: 'GET' })

		return data ? FacilityDetail(data) : null
	},

	updateFacilityById: async (id: string, payload: IFacilityDetailUpdate): Promise<IFacilityDetailModel | null> => {
		const { data } = await apiCommon<IFacilityDetail>(`${facilitiesAuthRoute}/${id}`, {
			method: 'PUT',
			body: payload,
		})

		return data ? FacilityDetail(data) : null
	},

	createFacility: async (payload: IFacilityDetailUpdate): Promise<IFacilityDetailModel | null> => {
		const { data } = await apiCommon<IFacilityDetail>(facilitiesAuthRoute, {
			method: 'POST',
			body: payload,
		})

		return data ? FacilityDetail(data) : null
	},
}
